import BiblioItemComment from 'models/biblioteca/BiblioItemComment';
import Styled from '../../subpages/socio/AdminSocioEmocional.styled';
import React from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';
import { capitalize } from 'lodash';
import { DateHelp } from 'core/util/DateHelp';
import AdminBiblioService from 'core/http/service/admin/AdminBiblio.service';
import { ToastError, ToastSuccess } from 'components/Toaster';

export interface Commentary {
    id: number;
    username: string;
    email: string;
    text: string;
}

export interface ModalCommentaryProps {
    show: boolean;
    onClose: () => void;
    commentarys: BiblioItemComment[];
}

const service = new AdminBiblioService();

export const ModalCommentary: React.FC<ModalCommentaryProps> = ({ show, onClose, commentarys }) => {
    const [answer, setAnswer] = React.useState<Record<number, string>>({});
    const [loading, setLoading] = React.useState<number>(-1);

    const [listaCommentarios, setListaComentarios] = React.useState<BiblioItemComment[]>(commentarys);


    const removerComentarioDaLista = (idCommentary: number) => {
        const novaLista = listaCommentarios.filter((commentary) => commentary.id !== idCommentary);
        setListaComentarios(novaLista);
    }

    const submitAnswer = async (idCommentary: number) => {
        try {
            setLoading(idCommentary);

            if (answer[idCommentary]) {
                const { status } = await service.adicionarResposta(idCommentary, answer[idCommentary]);

                if (status == 200) {
                    ToastSuccess('Resposta Enviada');
                    setAnswer({ ...answer, [idCommentary]: '' });
                    removerComentarioDaLista(idCommentary);
                } else {
                    ToastError('Erro ao enviar Resposta');
                }
            }
        } catch (error) {
            ToastError('Erro ao enviar Resposta');
        } finally {
            setLoading(-1);
        }
    };


    React.useEffect(() => {
        setListaComentarios(commentarys);
    }, [commentarys]);

    if (!show || !listaCommentarios) return null;
    return (
        <React.Fragment>
            <Modal show={show} onHide={onClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Comentários</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {listaCommentarios.map((commentary, index) => (
                        <>
                            <Styled.Modal.Title>{capitalize(commentary?.item?.category.toString() ?? '')}</Styled.Modal.Title>
                            <Styled.Modal.SubTitle>{capitalize(commentary?.item?.title ?? '')}</Styled.Modal.SubTitle>
                            <br />
                            <Styled.Modal.UserName>{commentary.username}</Styled.Modal.UserName>
                            <Styled.Modal.Date>{DateHelp.formatDateFull(commentary.dateAtualizacao)}</Styled.Modal.Date>
                            <Styled.Modal.Text>{commentary.comment}</Styled.Modal.Text>

                            <hr />

                            <FormControl
                                as="textarea"
                                rows={2}
                                value={answer[commentary.id] || ''}
                                onChange={e => setAnswer({ ...answer, [commentary.id]: e.target.value })}
                            />
                            <Styled.Modal.ButtonArea>
                                <Styled.Modal.GradientButton disabled={!answer[commentary.id] || loading === commentary.id} onClick={() => submitAnswer(commentary.id)}>
                                  {loading === commentary.id ? 'Enviando...' : 'Responder'}
                                </Styled.Modal.GradientButton>
                            </Styled.Modal.ButtonArea>
                        </>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};
